import { Injectable } from '@angular/core';
import { OrderHeaderModel } from '../models/order/orderheader.model';
@Injectable()
export class BadgeService{
    badge: number = 0;

    getBadge(){
        return this.badge;
    }
    incrementBadgeByValue(num: number){
        this.badge+=num;
    }
    incrementBadge(){
        this.badge++;
    }
    decreaseBadge(){
        if (this.badge > 0){
            this.badge--;
        }
    }
    resetBadge(){
        this.badge = 0;
    }
    resetBadgeAndCountOrder(order: OrderHeaderModel){
        this.badge = 0;

        let totalQty: number = 0;
        order.detail.forEach((item) => {
            totalQty = 0;
            totalQty += order.detail.length;
            item.foc_item.forEach((item) => {
                if (item.foc_item.length > 0) 
                    totalQty += item.foc_item.length;
            });
        });
        this.badge = totalQty;
    }
}


// WEBPACK FOOTER //
// ./src/services/badge.service.ts